<template>
  <button
    class="locking-button"
    :disabled="disabled || locked"
    @click="onButtonClicked"
  >
    {{ buttonText }}
    <LoadingPulse
      :loading="locked"
      class="loading-pulse"
    />
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import LoadingPulse from '@/components/shared/LoadingPulse.vue'

export default defineComponent({
  name: "LockingButton",
  components: {
    LoadingPulse
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  emits: [
    'click'
  ],
  computed: {
    buttonText(): string {
      return this.locked ? '' : this.text
    }
  },
  methods: {
    onButtonClicked(): void {
      this.$emit('click')
    }
  }
});
</script>

<style lang="scss" scoped>

.locking-button {
  @include positive-button;
  position: relative;

  > .loading-pulse {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

</style>